import React from "react";
import { Breadcrumbs, Link, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
const Breadcrumb = ({ path, breadCrumbItems }) => {
    return (React.createElement(Breadcrumbs, { "aria-label": "breadcrumb" }, breadCrumbItems.map((item, index) => {
        const last = index === breadCrumbItems.length - 1;
        const iconWithColor = React.isValidElement(item.icon)
            ? React.cloneElement(item.icon, {
                style: { color: "#007549", fontSize: "inherit" }
            })
            : item.icon;
        return last ? (React.createElement(Typography, { key: item.href },
            iconWithColor,
            " ",
            item.title)) : (React.createElement(Link, { sx: { color: "#007549", textDecoration: "none" }, key: item.href, component: RouterLink, to: item.href },
            iconWithColor,
            " ",
            item.title));
    })));
};
export default Breadcrumb;
